var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMpInstituteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9786 3.28354C28.3481 5.10625 31.8998 6.61685 31.8749 6.64181C31.8499 6.67303 31.3318 6.8915 30.7326 7.14119C30.1333 7.39087 29.5653 7.63432 29.4716 7.67801L29.2969 7.77164L29.2969 20H27.986V14.1636C27.986 10.9551 27.9673 8.32719 27.9361 8.32719C27.9111 8.32719 25.2145 9.43829 21.9499 10.7991L16.0011 13.2772L8.09231 9.9876C3.73529 8.17738 0.152306 6.67303 0.127336 6.64806C0.0898838 6.6106 15.3644 0.18744 15.9387 0.000175843C15.9886 -0.0185506 19.6091 1.46084 23.9786 3.28354Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.991 14.2697V17.2285L23.4417 17.6405C21.9374 18.7641 20.1771 19.4944 18.0922 19.8564C17.2121 20.0062 14.7901 20.0062 13.91 19.8564C11.7814 19.4881 9.79641 18.6455 8.37321 17.5094L8.01116 17.2222V14.2697C8.01116 12.653 8.02989 11.3234 8.04862 11.3234C8.06734 11.3234 9.86508 12.1224 12.0373 13.0962L16.0011 14.869L19.8837 13.1274C22.0185 12.1724 23.8163 11.3734 23.8787 11.3484C23.9848 11.3172 23.991 11.442 23.991 14.2697Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpInstituteIcon);
export default __webpack_public_path__ + "static/media/mp-institute-icon.f4d5a1512fe63c7183d9e3e578384ffc.svg";
export { ForwardRef as ReactComponent };